<form [formGroup]="form" class='ot-modal-wrapper' [ngClass]="{'ot-content-supplies-header': contentSuppliesHeader}">
  <div class='ot-modal-header-wrapper'>
    <button *ngIf="secondary.length > 0" type="button" (click)="secondaryClick()" [disabled]="!allowClose"
      class='ot-header-action-button'>{{secondary}}</button>
    <div class='ot-modal-title'>
      {{title}}
    </div>
    <button type="button" (click)="primaryClick()" [disabled]="!isValid || !allowClose"
      class='ot-header-action-button'>{{primary}}</button>
  </div>

  <div class='ot-modal-content-wrapper'>
    <ng-template dialog-component-host></ng-template>
  </div>
</form>